import { useResettableDebouncedValue } from '@/hooks/use-resettable-debounced-value';

interface UseTableSearchResult {
  /** Debounced value — pass this to the API/filter. */
  searchValue: string;
  /** Immediate value — bind this to the input. */
  inputValue: string;
  setInputValue: (v: string) => void;
  clearSearch: () => void;
}

export function useTableSearch(delayMs = 400): UseTableSearchResult {
  const { value, setValue, debounced, reset } = useResettableDebouncedValue(delayMs);
  return { searchValue: debounced, inputValue: value, setInputValue: setValue, clearSearch: reset };
}
